import { render, staticRenderFns } from "./bicycleshops.vue?vue&type=template&id=109b7c47&"
import script from "./bicycleshops.vue?vue&type=script&lang=ts&"
export * from "./bicycleshops.vue?vue&type=script&lang=ts&"
import style0 from "./bicycleshops.vue?vue&type=style&index=0&id=109b7c47&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TravelMap: require('/opt/atlassian/pipelines/agent/build/components/TravelMap.vue').default,LoaderSpinner: require('/opt/atlassian/pipelines/agent/build/components/LoaderSpinner.vue').default})
